<template>
  <!-- 实名认证弹窗 -->
  <div v-if="isshow" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ $t('_sz._bjxx') }}</h2>
        <button class="close-btn" @click="close">×</button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="onFinish">
          <div class="form-group">
            <label class="sdttqwe">{{ $t('_sz._tx') }}</label>
            <upload-file @onUpload="onFrontUpload" :imageUrl="imageFrontUrl"></upload-file>
          </div>

          <div class="form-actions">
            <!-- <button type="button" class="cancel-btn" @click="close">{{ $t('_sz._qx') }}</button> -->
            <button type="submit" class="submit-btn">{{ $t('_sz._bcun') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UploadFile from '@/components/UploadFile.vue'
export default {
  name: 'AuthBox',
  components: { UploadFile },
  data() {
    return {
      isshow: false,
      //店铺信息
      btnLoad: false,
      edit: {
        avatar: ''
      },

      imageFrontUrl: '',
      imgFront: ''
    }
  },
  created() {},
  methods: {
    show() {
      this.isshow = true
      this.$nextTick(function () {
        //获取信息
        this.getUserInfo()
      })
    },
    close() {
      this.isshow = false
      this.imageFrontUrl = ''
    },
    getUserInfo() {
      const that = this
      this.$api.user.getUserInfo().then((res) => {
        if (!res.data) {
          return
        }

        that.edit.avatar = res.data.avatar

        that.imageFrontUrl = res.data.avatar
      })
    },
    /**------------------------------
     * 保存个人信息
     * @param {*} values
     */
    onFinish() {
      if (this.btnLoad) {
        return
      }
      this.btnLoad = true

      this.edit.avatar = this.imgFront

      console.log('params:', this.edit)

      let that = this
      this.$message.loading({ content: this.$t('_a._bcz'), key: 'msg' })
      this.$api.user.update(this.edit).then((res) => {
        that.btnLoad = false
        if (res.code == 1) {
          that.$message.warning({ content: res.msg, key: 'msg' })
        } else {
          that.$message.success({ content: res.msg, key: 'msg' })
          that.$emit('success')
          that.close()
        }
      })
    },
    onFinishFailed(errorInfo) {
      console.log('Failed:', errorInfo)
    },
    onFrontUpload(img) {
      this.imageFrontUrl = img
      this.imgFront = img
    },
    onBackUpload(img) {
      this.imageBackUrl = img
      this.imgBack = img
    },
    onCompanyUpload(img) {
      this.imageCompanyUrl = img
      this.imgCompany = img
    }
  }
}
</script>

<style scoped>
@import url('../../static/css_setting/1.css');
</style>
<style scoped>
.rzlx >>> .ant-radio-group {
  display: flex !important;
}

.form-group >>> .upload-box {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
}
.form-group >>> .upload-box img {
  width: 100%;
  height: 100%;
}

.form-group >>> .upload-main {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sdttqwe {
  text-align: center;
}
</style>
